export default {"src":"/_next/static/media/icon-email.f9295269.svg","height":23,"width":29,"blurWidth":0,"blurHeight":0};